import React, { useState } from "react";

import Text from "components/common/Text";
import Link from "components/common/Link";
import ProfileMenu from "components/common/ProfileMenu";

import ChangePasswordDialog from "components/ChangePasswordDialog";
import PasswordChangedDialog from "components/PasswordChangedDialog";
import DeactivateAccountDialog from "./DeactivateAccountDialog";
import { localStore } from "stores/localStorage";
import { useAppLogout } from "hooks/useAppLogout";

/**
 * Overflow menu for All-In-One profile identity card
 * (Edit Profile / Change Password / Logout / Deactivate).
 */
const ProfileDetails = ({ deactivateDialogProps = {} }) => {
  const handleLogout = useAppLogout();
  const [passwordSuccessOpen, setPasswordSuccessOpen] = useState(false);

  const changePassword = () => (
    <ChangePasswordDialog
      passwordOpen={setPasswordSuccessOpen}
      openComponent={(onOpen) => (
        <Text
          variant="small"
          color={{ xs: "#e5e5e5", md: "#1D9BFF" }}
          sx={{
            textDecoration: "none",
            cursor: "pointer",
            color: "gray",
          }}
          onClick={onOpen}
        >
          Change Password
        </Text>
      )}
    />
  );

  const deactivateAccount = () => (
    <DeactivateAccountDialog
      openComponent={(onOpen) => (
        <Text
          variant="small"
          color={{ xs: "#e5e5e5", md: "#1D9BFF" }}
          sx={{
            textDecoration: "none",
            cursor: "pointer",
            color: "gray",
          }}
          onClick={onOpen}
        >
          Deactivate Account
        </Text>
      )}
      isLoading={false}
      open={deactivateDialogProps.open}
      onClose={deactivateDialogProps.onClose}
      onConfirm={deactivateDialogProps.onConfirm}
      checkboxChecked={deactivateDialogProps.checkboxChecked}
      onCheckboxChange={deactivateDialogProps.onCheckboxChange}
    />
  );

  const logout = () => (
    <Text
      variant="small"
      sx={{
        textDecoration: "none",
        cursor: "pointer",
        color: "gray",
      }}
      onClick={handleLogout}
    >
      Logout
    </Text>
  );

  const editProfile = () => (
    <Link
      variant="small"
      sx={{
        textDecoration: "none",
        cursor: "pointer",
        color: "gray",
      }}
      href="/customer/profile/edit-profile"
    >
      Edit Profile
    </Link>
  );

  const menuOptions = [
    { name: editProfile() },
    { name: changePassword() },
    { name: logout() },
  ];

  if (deactivateDialogProps.isEnabled) {
    menuOptions.push({ name: deactivateAccount() });
  }

  const menuListSize = deactivateDialogProps.isEnabled ? 40 : 25;

  return (
    <>
      {localStore.isSsoCustomer() ? null : (
        <ProfileMenu menuOptions={menuOptions} listSize={menuListSize} />
      )}
      <PasswordChangedDialog
        open={passwordSuccessOpen}
        passwordChange={setPasswordSuccessOpen}
      />
    </>
  );
};

export default ProfileDetails;
